import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * Width directive add padding of the html element
 * Its goal is to avoid the multitude of class css creation
 * Exemple :
 * <div padding=5px></div>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[padding]',
})
export class WizPaddingDirective implements OnInit {
  @Input() padding: string;

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'padding', this.padding);
  }
}
